import React, { PureComponent } from 'react'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import Popup from '@components/popups/basic-modal'
import AsyncCreatableSelect from 'react-select/async-creatable'
import style from '../index.module.scss'
import paymentStyle from './send-payment-link.module.scss'
import { isEnabled, phoneNumberFormat, validateEmail, validateMobile } from '@helpers/utility'
import Icon from '@components/icons'
import notification from '@components/notification'
import { TextInstruction } from '@components/textInstruction'
import config from '@config/index'
import { WisetackPromotionalMessageContainer } from '@app/containers/wisetack/WisetackPromotionalMessageContainer'
import { WisetackDisclosureContainer } from '@app/containers/wisetack/WisetackDisclosureContainer'
import { withTranslation } from 'react-i18next'
import { getFeatureVal, featureFlags } from '@helpers/configcat'
import SendInvoiceAttachments from '@components/InvoiceAttachments/SendInvoiceAttachments'
import { uploadPaymentLinkAttachments, prepareAttachmentsForInvoiceCreation } from '../invoice-attachment-service'

let isFormChanged = false

class SendPaymentLinkPopup extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      hasContact: false,
      selectedContact: '',
      editStatus: false,
      showWisetackContainer: false,
      // Attachment-related state
      supportPaymentLinkAttachment: false,
      uploadingAttachments: [],
      uploadedAttachments: []
    }
  }

  closeModal() {
    this.props.closeModal(isFormChanged)
    isFormChanged = false
  }

  handleCancel(values, { resetForm }) {
    this.props.closeModal(isFormChanged)
    isFormChanged = false
  }

  handleSubmit(values, { resetForm }) {
    if (this.state.hasContact) {
      const res = {
        contact_id:
          this.state.selectedContact && this.state.selectedContact.contact_id
            ? this.state.selectedContact.contact_id
            : '',
        customer_name: this.state.selectedContact && this.state.selectedContact.full_name,
        message: '',
        requested_amount: values.txtAmount,
        requested_through: {
          email: false,
          sms: false
        }
      }
      if (this.state.selectedContact && this.state.selectedContact.mobile) {
        res.customer_number = phoneNumberFormat(this.state.selectedContact.mobile)
        res.requested_through.sms = true
      }
      if (this.state.selectedContact && this.state.selectedContact.email) {
        res.customer_email = this.state.selectedContact.email
        res.requested_through.email = true
      }

      // Add attachments if feature is enabled and attachments exist
      if (this.state.supportPaymentLinkAttachment && this.state.uploadedAttachments.length > 0) {
        res.attachments = prepareAttachmentsForInvoiceCreation(this.state.uploadedAttachments)
        console.log('Payment link with attachments:', res.attachments)
      }

      if (!res.requested_through.email && res.requested_through.sms) {
        const me = this.props.me || {}
        const hasTwilioAssigned = me.account_settings && me.account_settings.twilio && me.account_settings.twilio.length
        const isTrialUser = me.role_id && me.role_id.role_name === 'trial'
        const twilioEnabled = hasTwilioAssigned || isTrialUser

        if (!twilioEnabled) {
          notification('error', this.props.t('payments.twilio-number-not-configured'))
          return
        }
      }
      this.props.sendGetPaidLink(res)
    }
  }

  async componentDidMount() {
    const me = this.props.me || {}

    // Check ConfigCat feature flag for payment link attachments
    try {
      // Use the existing invoice attachment flag for now
      const supportPaymentLinkAttachment = await getFeatureVal(featureFlags.supportInvoiceAttachment, me)
      console.log('Payment link attachment flag status (using invoice flag):', supportPaymentLinkAttachment)
      this.setState({ supportPaymentLinkAttachment })
    } catch (error) {
      console.error('Error getting payment link attachment feature flag:', error)
      // Default to false if there's an error
      this.setState({ supportPaymentLinkAttachment: false })
    }

    if (this.props && this.props.contactInfo) {
      await this.setState({
        contacts:
          this.props.contactInfo && this.props.contactInfo.email
            ? this.props.contactInfo.email
            : this.props.contactInfo.mobile,
        hasContact: true,
        selectedContact: this.props.contactInfo,
        editStatus: true
      })
    }
  }

  customOptions = ({ value, label, subLabel, image, contactObj, index }, { context }) => {
    if (context === 'value') {
      return (
        <div key={index} className="d-flex flex-grow-0">
          <div className="mr-10">
            <figure className={`mb-0 ${style['b-image']}`}>
              <img
                className={`w-100 rounded-circle ${style['image']}`}
                src={image || 'https://dufzo4epsnvlh.cloudfront.net/image/user_avatar.svg'}
                alt=""
              />
            </figure>
          </div>
          <div className="d-flex flex-grow-1 justify-content-between align-items-center">
            <div>{label || subLabel}</div>
          </div>
        </div>
      )
    }
    if (context === 'menu') {
      return (
        <React.Fragment>
          <div data-test="payment-link-contact-option" id="contactOptionValue" className="d-flex flex-grow-0">
            <div className="mr-10">
              <figure className={`mb-0 ${style['b-image']}`}>
                <img
                  className={`w-100 rounded-circle ${style['image']}`}
                  src={image || 'https://dufzo4epsnvlh.cloudfront.net/image/user_avatar.svg'}
                  alt=""
                />
              </figure>
            </div>
            <div className="d-flex flex-grow-1 justify-content-between align-items-center">
              <div>{label || subLabel}</div>
              <div>{label && subLabel ? `${subLabel}` : ''}</div>
            </div>
          </div>
        </React.Fragment>
      )
    }
  }

  autoSuggestContacts = async (input) => {
    const data = {
      nopaging: true,
      status: 'active',
      excludeNullGroup: true,
      search: input || ''
    }
    this.props.products &&
      isEnabled('contact-manager', this.props.products) &&
      (await this.props.autosuggestContacts(data))
    return [
      {
        options: this.props.contactList && this.props.contactList.length > 0 ? this.props.contactList : []
      }
    ]
  }

  createNewVisible(array) {
    if (array.length > 0) {
      if (array[0] && array[0].options.length === 0) {
        return true
      } else return false
    } else return false
  }

  async handleSelectOption(setFieldValue, data, field, action, amount) {
    isFormChanged = true

    if (action && action.action === 'clear') {
      this.setState({ contacts: [], hasContact: false, editStatus: false })
      setFieldValue(field, '')
    }
    if (data && data.value) {
      this.setState({ contacts: [data.value], hasContact: true, selectedContact: data.contactObj })
      setFieldValue(field, data.value)
    }
    if (action && action.action === 'create-option') {
      const mobileTest = validateMobile(data.value)
      const emailTest = validateEmail(data.value)
      if (data.value && !mobileTest && !emailTest) {
        const me = this.props.me || {}
        const hasTwilioAssigned = me.account_settings && me.account_settings.twilio && me.account_settings.twilio.length
        const isTrialUser = me.role_id && me.role_id.role_name === 'trial'
        const twilioEnabled = hasTwilioAssigned || isTrialUser

        const message = twilioEnabled
          ? this.props.t('payments.please-enter-a-valid-email-or-mobile')
          : this.props.t('payments.please-enter-a-valid-email')
        notification('error', message)
        this.setState({ contacts: [], hasContact: false })
        setFieldValue(field, '')
      } else {
        let type = ''
        if (mobileTest) {
          type = 'mobile'
          data.value = phoneNumberFormat(data.value)
        }
        if (emailTest) {
          type = 'email'
        }
        this.props.showContactAddPopup(type, data.value, amount)
      }
    }
  }

  wisetackAllowed(amount) {
    if (amount >= 500 && amount <= 25000) {
      this.setState({
        ...this.state,
        showWisetackContainer: true
      })
    } else {
      if (this.state.showWisetackContainer) {
        this.setState({
          ...this.state,
          showWisetackContainer: false
        })
      }
    }
  }

  // === ATTACHMENT METHODS ===

  uploadPaymentLinkAttachments = async ({ files }) => {
    if (!files || files.length === 0) return

    console.log(
      'Starting upload of files:',
      files.map((f) => f.name)
    )

    // Add files to uploading state
    const uploadingFiles = files.map((file) => ({
      name: file.name,
      size: file.size,
      type: file.type,
      progress: 0,
      cancelUpload: false,
      lastModified: file.lastModified
    }))

    this.setState({
      uploadingAttachments: [...this.state.uploadingAttachments, ...uploadingFiles]
    })

    // Upload each file
    for (let i = 0; i < files.length; i++) {
      const file = files[i]
      const uploadingFile = uploadingFiles[i]

      try {
        console.log(`Uploading file: ${file.name}`)

        const axiosConfig = {
          onUploadProgress: (progressEvent) => {
            const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total)
            this.updateUploadingFileProgress(uploadingFile.name, progress)
          }
        }

        const response = await uploadPaymentLinkAttachments({ file, axiosConfig, action: 'getpaid' })
        console.log(`Upload successful for ${file.name}:`, response)

        // Move from uploading to uploaded
        this.moveFileToUploaded(uploadingFile.name, response)
      } catch (error) {
        console.error(`Payment link attachment upload failed for ${file.name}:`, error)
        notification('error', `Failed to upload ${file.name}. Please try again.`)
        this.removeUploadingFile(uploadingFile.name)
      }
    }
  }

  updateUploadingFileProgress = (fileName, progress) => {
    this.setState({
      uploadingAttachments: this.state.uploadingAttachments.map((file) =>
        file.name === fileName ? { ...file, progress } : file
      )
    })
  }

  moveFileToUploaded = (fileName, response) => {
    const uploadingFile = this.state.uploadingAttachments.find((file) => file.name === fileName)
    if (!uploadingFile) return

    console.log('File upload response:', response)

    // Handle both raw object and { files: [...] } shape
    const respFile = response && response.files && response.files[0] ? response.files[0] : response

    const key = respFile && (respFile.key || respFile.s3Key)
    if (!key) {
      console.warn('Uploaded response missing key, skipping add to uploaded list')
      // Remove from uploading list to avoid getting stuck
      this.setState({
        uploadingAttachments: this.state.uploadingAttachments.filter((file) => file.name !== fileName)
      })
      return
    }

    const uploadedFile = {
      name: uploadingFile.name,
      originalname: respFile.originalname || uploadingFile.name,
      size: respFile.size != null ? respFile.size : uploadingFile.size,
      key: key,
      s3Key: key,
      mimetype: respFile.mimetype || uploadingFile.type,
      uploaded_at: respFile.uploaded_at || new Date().toISOString()
    }

    console.log('Created uploaded file object:', uploadedFile)

    this.setState({
      uploadingAttachments: this.state.uploadingAttachments.filter((file) => file.name !== fileName),
      uploadedAttachments: [...this.state.uploadedAttachments, uploadedFile]
    })
  }

  removeUploadingFile = (fileName) => {
    this.setState({
      uploadingAttachments: this.state.uploadingAttachments.filter((file) => file.name !== fileName)
    })
  }

  onCancelUploadingAttachment = (fileName) => {
    this.setState({
      uploadingAttachments: this.state.uploadingAttachments.filter((file) => file.name !== fileName)
    })
  }

  onClearUploadingAttachments = () => {
    this.setState({ uploadingAttachments: [] })
  }

  onClearUploadedAttachments = () => {
    this.setState({ uploadedAttachments: [] })
  }

  onRemoveUploadedAttachment = (fileName) => {
    this.setState({
      uploadedAttachments: this.state.uploadedAttachments.filter((file) => file.name !== fileName)
    })
  }

  // === END ATTACHMENT METHODS ===

  render() {
    const t = this.props.t
    return (
      <React.Fragment>
        <Popup
          open={this.props.open}
          title={t('payments.send-payment-link')}
          hideFooter={true}
          onCancel={() => this.closeModal.bind(this)}
          type="basic"
          modalBackdropClicked={() => console.log(null)}
          id="modalSendPaymentLink">
          <Formik
            validateOnChange={false}
            validateOnBlur={false}
            initialValues={{
              txtAmount: this.props && this.props.amount ? this.props.amount : '',
              txtContact: ''
            }}
            validationSchema={Yup.object().shape({
              txtContact: Yup.string().test(
                'len',
                t('payments.only-us-phone-numbers-without-country-code-are-permitted-eg-500-555-0006'),
                (val) => (val ? val.length === 14 : true)
              ),
              txtAmount: Yup.number().required(t('payments.required'))
            })}
            onReset={this.handleCancel.bind(this)}
            onSubmit={this.handleSubmit.bind(this)}
            render={({ values, setFieldValue }) => {
              return (
                <Form
                  id="frmSentPayemntLink"
                  name="frmSentPayemntLink"
                  className={`pt-20 custom-get-paid-form ${style['get-paid-form']}`}>
                  <button
                    name="btngetPaidCloseModal"
                    type="reset"
                    className="close custom-modal-close-button remove-modal-close">
                    <span aria-hidden="true">×</span>
                  </button>
                  <div className="row">
                    <div className="col-12">
                      <div className="form-group">
                        <label className="label-text ">
                          {t('payments.amount-1')} <span className="star">*</span>
                        </label>
                        <ErrorMessage
                          id="frmSentPayemntLink_amountError"
                          name="txtAmount"
                          component="span"
                          className="form-error"
                        />
                        <div className="position-relative">
                          <Field
                            data-test="payment-link-amount-field"
                            id="frmSendPaymentLink_txtAmount"
                            className="form-control form-control-lg mb-20 pl-25"
                            type="text"
                            placeholder={t('payments.enter-amount-0')}
                            name="txtAmount"
                            value={values.txtAmount}
                            maxLength={config.amountFieldLength}
                            onChange={(e) => {
                              const { value } = e.target
                              const regex = /^(0*[0-9][0-9]*(\.[0-9]{0,2})?|0*\.[0-9]{0,2})$/
                              if (regex.test(value.toString()) || value.length === 0) {
                                isFormChanged = true
                                setFieldValue('txtAmount', value)
                              }
                            }}
                            onBlur={() => this.wisetackAllowed(values.txtAmount)}
                          />
                          <span className={`position-absolute ${style['dollar-sing']}`}>$</span>
                        </div>
                        {this.props.showInstruction && values.txtAmount === '' && (
                          <TextInstruction
                            className={paymentStyle['payment-instruction-amount']}
                            strongMessage={t('payments.take-action')}
                            message={t('payments.enter-the-amount-youd-like-to-bill-your-customer')}
                          />
                        )}
                        {this.state.showWisetackContainer && (
                          <WisetackPromotionalMessageContainer
                            isSingleLineLayout
                            amountInCents={Number(values.txtAmount) * 100}
                          />
                        )}
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-group custom-form-group-dropdown mb-10 custom-cursor-hide">
                        <label className="label-text">
                          {t('payments.contact')} <span className="star">*</span>
                        </label>
                        <ErrorMessage name="contacts" component="span" className="form-error" />
                        {this.props && this.props.contactInfo && this.state.hasContact && this.state.editStatus ? (
                          <AsyncCreatableSelect
                            data-test="payment-link-contact-field"
                            id="frmSendPaymentLink_txtContact"
                            name="contacts"
                            isClearable
                            placeholder={t('payments.name-phone-or-email')}
                            className="dropdown-select no-arrow-down"
                            classNamePrefix="dropdownSelect"
                            loadOptions={this.autoSuggestContacts}
                            formatOptionLabel={this.customOptions}
                            noOptionsMessage={() => null}
                            menuIsOpen={true}
                            value={
                              this.props && this.props.contactInfo
                                ? {
                                    label: this.props.contactInfo.first_name,
                                    value: this.props.contactInfo.email
                                      ? this.props.contactInfo.email
                                      : this.props.contactInfo.mobile
                                  }
                                : ''
                            }
                            onChange={(event, type) =>
                              this.handleSelectOption(setFieldValue, event, 'contacts', type, values.txtAmount)
                            }
                            formatCreateLabel={(userInput) => (
                              <div className="react-select-unavailable-data">
                                <span className="react-select-highlight-text">{t('payments.send-to')}</span> {userInput}
                              </div>
                            )}
                            isValidNewOption={(inputValue, selectValue, selectOptions) =>
                              this.createNewVisible(selectOptions)
                            }
                          />
                        ) : (
                          <AsyncCreatableSelect
                            data-test="payment-link-contact-field"
                            id="frmSendPaymentLink_txtContact"
                            name="contacts"
                            isClearable
                            placeholder={t('payments.name-phone-or-email')}
                            className="dropdown-select no-arrow-down"
                            classNamePrefix="dropdownSelect"
                            loadOptions={this.autoSuggestContacts}
                            formatOptionLabel={this.customOptions}
                            noOptionsMessage={() => null}
                            menuIsOpen={true}
                            onChange={(event, type) =>
                              this.handleSelectOption(setFieldValue, event, 'contacts', type, values.txtAmount)
                            }
                            formatCreateLabel={(userInput) => (
                              <div className="react-select-unavailable-data">
                                <span className="react-select-highlight-text">{t('payments.send-to')}</span> {userInput}
                              </div>
                            )}
                            isValidNewOption={(inputValue, selectValue, selectOptions) =>
                              this.createNewVisible(selectOptions)
                            }
                          />
                        )}

                        {this.props.showInstruction && values.txtAmount !== '' && !this.state.hasContact && (
                          <TextInstruction
                            className={paymentStyle['payment-instruction-contact']}
                            strongMessage={t('payments.take-action')}
                            message={t('payments.enter-the-phone-number-or-email-of-a-customer-to-send-a-payment-link')}
                          />
                        )}
                      </div>
                    </div>

                    {/* Attachment Section - Controlled by ConfigCat feature flag */}
                    {this.state.supportPaymentLinkAttachment && (
                      <SendInvoiceAttachments
                        uploadingAttachments={this.state.uploadingAttachments}
                        uploadedAttachments={this.state.uploadedAttachments}
                        onCancelUploadingAttachment={this.onCancelUploadingAttachment}
                        onClearUploadingAttachments={this.onClearUploadingAttachments}
                        onClearUploadedAttachments={this.onClearUploadedAttachments}
                        onRemoveUploadedAttachment={this.onRemoveUploadedAttachment}
                        uploadInvoiceAttachments={this.uploadPaymentLinkAttachments}
                        maxFileCount={5}
                        module="getpaid"
                      />
                    )}

                    {this.state.showWisetackContainer && (
                      <div className="col-12 mb-30">
                        <WisetackDisclosureContainer amountInCents={Number(values.txtAmount) * 100} />
                      </div>
                    )}
                  </div>
                  {this.state.hasContact ? (
                    <footer className="d-block d-sm-flex">
                      <button
                        data-test="send-payment-link-form-btn"
                        className={'btn btn-primary border-0 btn-xl mb-10 mb-sm-0 mr-20 btn-block'}
                        id="frmBtnSendPaymentLink"
                        disabled={this.props.paymentLinkLoader}
                        type="submit">
                        {t('payments.send-payment-link-0')}
                        {this.props.paymentLinkLoader && (
                          <i className={'btn-icon top-minus-2 mr-5 btn-loader'}>
                            <Icon name="spinner" />
                          </i>
                        )}
                      </button>
                      <button
                        data-test="cancel-payment-link-form-btn"
                        type="reset"
                        id="frmBtnSendPaymentLink_btnCancel"
                        className={'btn btn-xl m-0 cancel-btn custom-btn-width'}>
                        {t('payments.cancel-0')}
                      </button>
                    </footer>
                  ) : null}
                </Form>
              )
            }}
          />
        </Popup>
      </React.Fragment>
    )
  }
}

export default withTranslation(null, { withRef: true })(SendPaymentLinkPopup)
